import Box from '@mui/material/Box';
import React from 'react';

import { ConfigurationSection } from './ConfigurationSection';
import { IdentitySection } from './IdentitySection';
import { MainPartEditProps, MainPartEditTouched } from './MainPartEdit.props';
import { StatusPlacementSection } from './StatusPlacementSection';

const DEFAULT_TOUCHED: MainPartEditTouched = {
  serial1: false,
  condition: false,
  configReason: false,
};

export const MainPartEdit: React.FC<MainPartEditProps> = ({
  permissions,
  value,
  partType,
  partLocation,
  conditions,
  sfhDetails,
  selectedTags,
  allTags,
  newTags,
  isConfigDirty = false,
  touched = DEFAULT_TOUCHED,
  validate = false,
  exceptionSlot,
  duplicatesSlot,
  setTouched,
  setSelectedTags,
  setNewTags,
  onChange,
  handlePartTypeChange,
  handlePartLocationChange,
}) => {
  const markTouched = (key: keyof MainPartEditTouched) => () => {
    if (!setTouched || touched[key]) return;
    setTouched({ ...touched, [key]: true });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.75 }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: 1.75,
          alignItems: 'stretch',
        }}
      >
        <IdentitySection
          value={value}
          partType={partType}
          canEditSerial={permissions.isSerial}
          canEditPartType={permissions.isPartType}
          touched={touched}
          validate={validate}
          onChange={onChange}
          onTouchSerial1={markTouched('serial1')}
          handlePartTypeChange={handlePartTypeChange}
        />
        <ConfigurationSection
          value={value}
          sfhDetails={sfhDetails}
          isConfigDirty={isConfigDirty}
          touched={touched}
          validate={validate}
          selectedTags={selectedTags}
          newTags={newTags}
          allTags={allTags}
          setSelectedTags={setSelectedTags}
          setNewTags={setNewTags}
          onChange={onChange}
          onTouchReason={markTouched('configReason')}
        />
      </Box>
      <StatusPlacementSection
        value={value}
        conditions={conditions}
        partType={partType}
        partLocation={partLocation}
        canEditCondition={permissions.isCondition}
        canEditLocation={permissions.isLocation}
        canEditClientHierarchy={permissions.isClientHierarchy}
        validate={validate}
        touched={touched}
        exceptionSlot={exceptionSlot}
        duplicatesSlot={duplicatesSlot}
        onChange={onChange}
        onTouchCondition={markTouched('condition')}
        handlePartLocationChange={handlePartLocationChange}
      />
    </Box>
  );
};
